import LoginByGraphIdPage from "pages/LoginPage/LoginByGraphIdPage";
import { Route, Routes } from "react-router-dom";
import PluginTeamsHomePageRouter from "./PluginTeamsHomePageRouter";
import TeamsTaskGradingEditPrivatePage from "./TeamsTaskGradingEditPrivatePage";
import TeamsTaskGradingEditPublicPage from "./TeamsTaskGradingEditPublicPage";

export default function PluginGroupwardRouter() {
  return (
    <Routes>
      <Route path='' element={<PluginTeamsHomePageRouter />} />
      <Route path='openlogin' element={<LoginByGraphIdPage loginPath='open' />} />
      <Route path='closelogin' element={<LoginByGraphIdPage loginPath='close' />} />
      <Route path='open' element={<TeamsTaskGradingEditPublicPage />} />
      <Route path='close' element={<TeamsTaskGradingEditPrivatePage />} />
    </Routes>
  );
}
